import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
  ({ palette, typography, spacing }) => ({
    root: {
      fontWeight: typography.fontWeightBold,
      color: palette.grey.shade[90],
      marginBottom: spacing(3)
    }
  })
)

const Title = props => {
  const classes = useStyles()

  return (
    <Typography
      variant='h3'
      component='h1'
      align='center'
      className={classes.root}
      {...props}
    />
  )
}

export default Title
